var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 5.5C1.33301 4.09987 1.33301 3.3998 1.60549 2.86502C1.84517 2.39462 2.22763 2.01217 2.69803 1.77248C3.23281 1.5 3.93288 1.5 5.33301 1.5H10.6663C12.0665 1.5 12.7665 1.5 13.3013 1.77248C13.7717 2.01217 14.1542 2.39462 14.3939 2.86502C14.6663 3.3998 14.6663 4.09987 14.6663 5.5V16.5L12.3747 14.8333L10.2913 16.5L7.99967 14.8333L5.70801 16.5L3.62467 14.8333L1.33301 16.5V5.5Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoiceIcon.ac24344a4e995acde56da34bc4c2175d.svg";
export { ForwardRef as ReactComponent };